import { useQuery } from "react-query";
import { RiwayatPendidikanResponse } from "../../../../models/RiwayatPendidikan";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allRiwayatPendidikanKey = "all-riwayat-pendidikan-key";

export async function allRiwayatPendidikan(): Promise<
  RiwayatPendidikanResponse[]
> {
  const res = await ApiClient.get(`/AllPendidikan`);
  return res.data;
}

export default function useFetchAllRiwayatPendidikan() {
  return useQuery(
    [allRiwayatPendidikanKey],
    queryWrapper(allRiwayatPendidikan)
  );
}
